export default class {
  constructor() {
    let callbacks = {}

    this.on = function (eventType, callback) {
      if (!(eventType in callbacks)) {
        callbacks[eventType] = []
      }

      callbacks[eventType].push(callback)
    }

    this.off = function (eventType, callback) {
      if (!eventType) {
        callbacks = {}
      } else {
        if ((eventType in callbacks)) {
          if (!callback) {
            callbacks[eventType] = []
          } else {
            callbacks[eventType] = callbacks[eventType].filter(x => x !== callback)
          }
        }
      }

    }

    this.emit = function (eventType, ...arg) {
      if ((eventType in callbacks)) {
        return callbacks[eventType].reduce((p, c, i, a) => {
          return (c(...arg) !== false) && p
        }, true)
      }
      return true
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/EventSource/index.js